"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
exports.default = {
    root: {
        maxWidth: constants_1.ISOLATE_MAX_WIDTH,
        marginLeft: 'auto',
        marginRight: 'auto'
    }
};
//# sourceMappingURL=isolate.main.style.js.map